import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { FavDrugs } from "../../Apis/AuthApiServices";
import { loadingAllFavDrugs, setAllFavDrugs } from "../Slice/FavDrugsSlice";

function* onLoadAllFavDrugsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("sortByAlpha", payload.sortByAlpha);
  params.append("drugName", payload.drugName);
  try {
    const result: AxiosResponse = yield FavDrugs(params);
    if (result.data.digitalRxStatusCode === 200) {
      yield put(
        setAllFavDrugs({
          AllFavDrugsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setAllFavDrugs({
          AllFavDrugsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setAllFavDrugs({
        AllFavDrugsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadFavDrugs() {
  yield takeLatest(loadingAllFavDrugs.type, onLoadAllFavDrugsAsync);
}

const AllFavDrugsSaga = [fork(onLoadFavDrugs)];
export default AllFavDrugsSaga;
